import { Calendar, type CalendarProps } from '@/components/ui/calendar';
import { cn } from '@/lib/utils';

const CAPTION_NAV_BUTTON_CLASS = cn(
  '[&>div:first-child>button]:rounded-full [&>div:first-child>button]:border-primary/15 [&>div:first-child>button]:bg-card',
  '[&>div:first-child>button]:hover:bg-primary/8 [&>div:first-child>button]:hover:text-primary',
);

const DATE_CALENDAR_CLASS_NAMES: CalendarProps['classNames'] = {
  month: cn('flex flex-col gap-3', CAPTION_NAV_BUTTON_CLASS),
  weekday: 'w-9 text-center text-3xs font-semibold tracking-wider text-muted-foreground uppercase',
  week: 'mt-1 flex w-full',
  day_button: cn(
    'inline-flex size-9 items-center justify-center rounded-lg text-sm tabular-nums transition-colors',
    'hover:bg-primary/8 hover:text-primary',
    'focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:outline-none',
  ),
  selected: cn(
    '[&>button]:bg-linear-to-br [&>button]:from-primary [&>button]:to-primary-strong',
    '[&>button]:font-semibold [&>button]:text-primary-foreground [&>button]:hover:text-primary-foreground',
    '[&>button]:shadow-[0_6px_14px_-6px_color-mix(in_oklab,var(--color-primary)_70%,transparent)]',
  ),
  today: cn(
    '[&>button]:font-semibold',
    '[&:not([data-selected])>button]:text-primary [&:not([data-selected])>button]:ring-1 [&:not([data-selected])>button]:ring-primary/35',
  ),
  outside: '[&>button]:text-muted-foreground/50',
  disabled: '[&>button]:pointer-events-none [&>button]:text-muted-foreground/40',
};

export function DateCalendar({ classNames, ...calendarProps }: CalendarProps) {
  return (
    <Calendar classNames={{ ...DATE_CALENDAR_CLASS_NAMES, ...classNames }} {...calendarProps} />
  );
}
